import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './faqs.css'; // We'll define custom styles here

const FAQs = () => {
  const faqs = [
    {
      question: 'What is Vanshika Micro Creditlle and how does it work?',
      answer: 'Vanshika Micro Credit is a trusted digital lending platform designed for salaried professionals seeking quick personal loans. With a seamless online application, instant approval, and swift, secure fund disbursal, it ensures a premium borrowing experience.',
    },
    {
      question: 'What documents are required to apply for a loan?',
      answer: 'To apply for a loan, applicants are generally required to provide basic KYC and income verification documents. These include Aadhaar card, PAN card, recent salary slips, and bank account statements.',
    },
    {
      question: 'How fast is the loan disbursal process?',
      answer: 'Once your application is approved, the loan amount is typically disbursed within 24 hours, and in many cases, even sooner for eligible applicants.',
    },
    {
      question: 'Is my data safe with Vanshika Micro Creditlle?',
      answer: 'Your data is fully protected with Vanshika Micro Credit. We employ advanced encryption protocols and adhere strictly to applicable data protection laws and RBI regulatory guidelines, ensuring the highest level of security and confidentiality at every stage.',
    },
    {
      question: 'Can I repay my loan early?',
      answer: 'Yes, Vanshika Micro Credit allows loan prepayment, subject to the terms and conditions of your loan agreement. For details on charges or process, please refer to your agreement or contact our support team.',
    },
  ];

  return (
    <section className="faq-section py-3">
      <div className="container">
        <h2 style={{ color: '#052daa', textAlign: 'center', marginBottom: '2rem' }}>Frequently Asked Questions</h2>
        <div className="accordion" id="faqAccordion">
          {faqs.map((faq, index) => (
            <div className="accordion-item border-0 mb-3 shadow-sm" key={index}>
              <h2 className="accordion-header" id={`heading${index}`}>
                <button
                  className={`accordion-button ${index !== 0 ? 'collapsed' : ''}`}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                >
                  {faq.question}
                </button>
              </h2>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${index === 0 ? 'show' : ''}`}
                aria-labelledby={`heading${index}`}
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQs;
